<template>
  <div class="center">
    <audio class="audio"  style="display: none" controls :src="url" @pause="handlePause" @canplay="getDuration" @timeupdate="updateTime" ref="audio"></audio>
    <div class="audio_box" :style="styles">
      <img v-if="!flag"  src="../../assets/images/home/u7400.png" alt="" @click.stop="handlePlay">
      <img v-else  src="../../assets/images/home/u7402.png" alt="" @click.stop="handlePlay">
      <div class="ProgressBar" ref="ProgressBar" @mousemove="handleMousemove" @click="handleOperate">
        <div class="nowTime" :style="{left:width_init+'%'}">
          <div class="scroll_box"></div>
          <div class="scroll_time">{{playTime}}</div>
        </div>
        <div class="hidden_div" :style="{width:width_init+'%'}"></div>
      </div>
      <div class="allTime">{{duration}}</div>
    </div>
  </div>
</template>

<script>
  import {_changeTimeBySecond ,_addZero,_timeFormat} from '../../utils/index'
  export default {
    name: "Index",
    props:{
      styles: Object,
      url: {
        // 尺寸样式
        type: String,
        default: "mini"
      },
    },
    data(){
      return {
        flag:false,
        flag_click:false,
        offsetX:null,    // 鼠标到元素左边到距离
        playTime:'00:00', // 当前播放时长
        duration:null,  //总时长
        duration_ss:null,
        currentTime_ss:null,
        width_init:'',
      }
    },
    methods:{
      getDuration(e){
        this.duration_ss = Math.round(e.target.duration )
        let duration  =_timeFormat(Math.round(e.target.duration ))
        this.duration = duration
      },
      updateTime(e){
        this.currentTime_ss = Math.round(e.target.currentTime )
        let duration  =_timeFormat(Math.round(e.target.currentTime ))
        this.playTime = duration
      },
      handlePlay() {
        if(!this.flag){
          this.$refs.audio.play()
          this.flag = true
        }else{
          this.$refs.audio.pause()
          this.flag = false
        }
        return false
      },
      handlePause(){
        this.flag = false
      },
      // 滑动
      handleMousemove(e) {
        let followcheckedx = e.offsetX;
        this.offsetX = e.offsetX;
        let width = this.$refs.ProgressBar.clientWidth
        this.slidePlace = followcheckedx/width*100
        // 只有鼠标按下执行f
        // if(this.flag_click){
        //   console.log(1);
        //   this.width_init = this.offsetX / this.$refs.ProgressBar.clientWidth *100
        // }
      },
      // 点击
      handleOperate() {
        var audio = this.$refs.audio;
        audio.currentTime = this.slidePlace/100 * this.duration_ss
        this.width_init = this.slidePlace
        audio.play()
        this.flag = true
      },
    },
    watch:{
      playTime:{
        handler(){
          this.width_init = this.currentTime_ss/this.duration_ss *100
        }
      },
      slidePlace:{
        handler() {

        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .center {
    .audio_box{
      border-radius: 150px;
      display flex
      align-items center
      justify-content space-between
      padding 0 10px
      position relative
      >img{
        width: 80px
        height: 80px
        cursor: pointer
        margin-right 20px
      }
      .ProgressBar{
        width: 650px;
        height: 21px;
        background-color: rgba(242, 242, 242, 1);
        position relative
        .nowTime{
          position absolute
          left:0px
          top:-25%
          /*transition 1s;*/
          .scroll_time{
            font-size: 16px;
            color: #868686;
            transform translateY(10px)  translateX(-20px)
          }
          .scroll_box{
            width: 19px;
            height: 32px;
            background-color: rgba(242, 242, 242, 1);
          }
        }
        .hidden_div{
          /*transition 1s*/
          position absolute
          top:0
          left:0
          background deepskyblue
          height: 21px;
        }
      }
      .allTime{
        font-size: 16px;
        color: #868686;
        position absolute
        right:30px
        top:50%
        transform translateY(-250%)
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/audio/ProgressBar.vue